import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { DetailVersandart } from '@/types/detail';

type LookupResponse<T> = { type: string; items: T[] };

/**
 * Die gepflegte Liste der Versandarten.
 *
 * Stand vorher zweimal als useQuery im Baum — einmal in der
 * Detailansicht, einmal nirgends, weil das Erfassungs-Formular die
 * Versandart gar nicht kannte. Mit A7.2 braucht sie ein zweiter Ort, und
 * zwei Abfragen mit demselben Schluessel, aber je eigener Haltbarkeit
 * laufen frueher oder spaeter auseinander.
 */
export function useVersandarten() {
  return useQuery({
    queryKey: ['lookups', 'versandarten'],
    queryFn: () =>
      apiFetch<LookupResponse<DetailVersandart>>('/lookups.php?type=versandarten'),
    staleTime: 10 * 60_000
  });
}

/** Der eine Code, der Abholung von Versand unterscheidet (E20). */
export const CODE_ABHOLUNG = 'abholung';

/**
 * Der Sammelbegriff "Versand" — die Versandart, die gilt, wenn beim
 * Erfassen noch niemand weiss, wie es rausgeht.
 *
 * Sie wird ueber ihren Code gesucht, nicht ueber ihre Bezeichnung: der
 * Code ist der Schluessel, die Bezeichnung pflegt der Admin. Seit
 * Migration 025 heisst `post` sichtbar "Versand"; hiesse er morgen
 * anders, aendert das hier nichts.
 */
export const CODE_VERSAND_SAMMEL = 'post';

/** Alles ausser Abholung ist Versand. */
export function istVersandCode(code: string | null | undefined): boolean {
  return code !== null && code !== undefined && code !== CODE_ABHOLUNG;
}
